<div class="sat-type-row">
  <div class="sat-type-row__meta">
    <div class="sat-type-row__name">{{ attributeType.name }}</div>
    <div class="sat-type-row__detail">Value type: {{ attributeType.valueTypeLabel }}</div>
    <div class="sat-type-row__detail" *ngIf="attributeType.sourceField">
      Source field: {{ attributeType.sourceField }}
    </div>
  </div>

  <div class="sat-type-row__values">
    <span class="sat-tag" [ngClass]="tagClass" *ngFor="let value of visibleValues">{{ value.label }}</span>
    <span class="sat-more-values" *ngIf="hiddenValueCount > 0">+{{ hiddenValueCount }} more</span>
  </div>

  <div class="sat-type-row__actions">
    <div class="sat-type-row__filter" *ngIf="canEnableFilter">
      <mat-slide-toggle
        class="sat-filter-toggle"
        [checked]="localFilterEnabled"
        [disabled]="filterToggleSaving"
        (change)="onFilterToggle($event.checked)"
        matTooltip="Show this attribute in Version Search and Offer Association filters"
        matTooltipPosition="above">
        Use in filters
      </mat-slide-toggle>
    </div>
    <button *ngIf="canEditValues" type="button" class="sat-btn sat-btn--outline sat-btn--icon" title="Edit values" (click)="onEditValues()">
      <mat-icon>edit</mat-icon>
    </button>
    <button type="button" class="sat-btn sat-btn--danger sat-btn--icon" title="Delete attribute type" (click)="onDeleteType()">
      <mat-icon>delete</mat-icon>
    </button>
  </div>
</div>
